import Icon from '../components/Icon.vue'

Icon.register({
  'expand-arrows-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448.1 344V456C448.1 469.3 437.4 480 424.1 480H312.1C290.7 480 280 454.1 295.1 439L331.3 402.8 224 295.6 116.8 402.9 153 439C168.1 454.1 157.4 480 136 480H24C10.7 480 0 469.3 0 456V344C0 322.6 25.9 311.9 41 327L77.2 363.2 184.5 256 77.2 148.7 41 185C25.9 200.1 0 189.4 0 168V56C0 42.7 10.7 32 24 32H136C157.4 32 168.1 57.9 153 73L116.8 109.2 224 216.4 331.3 109.1 295.1 73C280 57.9 290.7 32 312.1 32H424.1C437.4 32 448.1 42.7 448.1 56V168C448.1 189.4 422.2 200.1 407.1 185L370.9 148.8 263.6 256 370.9 363.3 407.1 327.1C422.2 311.9 448.1 322.6 448.1 344z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/expand-arrows-alt.js
// module id = 71zK
// module chunks = 144